import styles from './PrintLink.module.css';

/**
 * Quiet "Tour" text link in the same style as PrintLink (grey, tints to the act colour
 * on hover, hidden in print). Reopens the reader's guided tour.
 */
export function TourLink({ accent, onClick }: { accent?: string; onClick: () => void }) {
  return (
    <button
      type="button"
      className={styles.printLink}
      onClick={onClick}
      title="Guided tour of this reader"
      aria-label="Open guided tour"
      style={accent ? ({ '--print-accent': accent } as React.CSSProperties) : undefined}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        <circle cx="12" cy="12" r="10" />
        <path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 2.5-3 4" />
        <line x1="12" y1="17" x2="12" y2="17.01" />
      </svg>
      <span className={styles.t}>Tour</span>
    </button>
  );
}
